// src/services/createSaleService.js
import axiosInstance from './axiosConfig';

const createSaleService = {

  // ─── Invoice ─────────────────────────────────────────────────────────────
  getInvoiceNumber: async () => {
    const response = await axiosInstance.get('/sales/invoice-number');
    return response.data.data ?? response.data;
  },

  // ─── Inventory ────────────────────────────────────────────────────────────
  getActiveInventories: async () => {
    const response = await axiosInstance.get('/inventories/active');
    return response.data.data ?? response.data;
  },

  // ─── Categories (all active categories) ──────────────────────────────────
  getAllCategories: async () => {
    const response = await axiosInstance.get('/categories/all');
    return response.data.data ?? response.data;
  },

  // ─── Products (scoped to category) ───────────────────────────────────────
  getProductsByCategory: async (categoryId) => {
    const response = await axiosInstance.get(`/products?categoryId=${categoryId}&limit=10000`);
    return response.data.data ?? response.data;
  },

  // ─── Stock (scoped to inventory + product) ────────────────────────────────
  getStockByInventoryAndProduct: async (inventoryId, productId) => {
    const response = await axiosInstance.get(`/stocks/all?inventoryId=${inventoryId}&productId=${productId}`);
    return response.data.data ?? response.data;
  },

  // ─── Routes ───────────────────────────────────────────────────────────────
  getAvailableRoutes: async () => {
    const response = await axiosInstance.get('/routes/available');
    return response.data.data ?? response.data;
  },

  // ─── Customers (scoped to route) ──────────────────────────────────────────
  getCustomersByRoute: async (routeId) => {
    const response = await axiosInstance.get(`/customers/routes/drop/${routeId}`);
    return response.data.data ?? response.data;
  },

  // ─── Sales ────────────────────────────────────────────────────────────────
  create: async (payload) => {
    const response = await axiosInstance.post('/sales/user/create', payload);
    return response.data;
  },

};

export default createSaleService;
